import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { secondaryMarketCpOrderFormFieldChanged } from 'state/secondaryMarket/cpOrder';
import {
  getOrderErrorMessage,
  getOrderTimeout,
  isOrderTimeout,
} from 'state/secondaryMarket/cpOrder/order/order.selector';
import { secondaryMarketCpOrderPlacementRequestedThunk } from 'state/secondaryMarket/cpOrder/order/order.thunks';
import { fromSecondaryMarket, getIsUserInternal } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
  className?: string;
}>;

type StateProps = Readonly<{
  errorMessage: string;
  timeout?: number;
  isInternalUser: boolean;
  hasTimeout: boolean;
  comment: string | undefined;
}>;

type DispatchProps = Readonly<{
  onPlaceOrder: () => void;
  onCommentChanged: (value: string) => void;
}>;

export type RejectedOrderSidePanelProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps: (state: AppState, ownProps: OwnProps) => StateProps = (state, { tabId }) => {
  const errorMessage = getOrderErrorMessage(state, tabId)!;
  const timeout = getOrderTimeout(state, tabId)!;
  const hasTimeout = isOrderTimeout(state, tabId) ?? false;
  const isInternalUser = getIsUserInternal(state);
  const comment = fromSecondaryMarket.cpOrder.form.getFormComment(state, tabId);

  return {
    errorMessage,
    hasTimeout,
    timeout,
    comment,
    isInternalUser,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    onPlaceOrder() {
      dispatch(secondaryMarketCpOrderPlacementRequestedThunk(tabId));
      logAnalytics.trackEvent('Secondary market', 'Request for place order');
    },
    onCommentChanged: value => {
      dispatch(secondaryMarketCpOrderFormFieldChanged(tabId, 'comment', value));
    },
  };
};

export const connectRejectedOrderSidePanel = connect(mapStateToProps, mapDispatchToProps);
